const topRatedTvShows = [
	{
		title: "Breaking Bad",
		description:
			"Walter White, a New Mexico chemistry teacher, is diagnosed with Stage III cancer and given a prognosis of only two years left to live. He becomes filled with a sense of fearlessness and an unrelenting desire to secure his family's financial future at any cost as he enters the dangerous world of drugs and crime.",
		release_date: "2008-01-20",
		imdb_id: "tt0903747",
		imdb_rating: "8.908",
		vote_count: "13640",
		popularity: "600.507",
		youtube_trailer_key: "HhesaQXLuRY",
		rated: "TV-MA",
		runtime: 49,
		year_started: 2008,
		genres: ["Drama", "Crime", "Thriller", "Western", "Suspense"],
		stars: [
			"Bryan Cranston",
			"Aaron Paul",
			"Anna Gunn",
			"Dean Norris",
			"Betsy Brandt",
			"RJ Mitte",
			"Bob Odenkirk",
			"Jonathan Banks",
			"Giancarlo Esposito",
			"Steven Michael Quezada",
			"Charles Baker",
			"Jesse Plemons",
		],
		creators: ["Vince Gilligan", "Michelle MacLaren", "Adam Bernstein"],
		countries: ["USA"],
		language: ["en", "de", "es", "English, Spanish"],
		production_companies: [
			"Sony Pictures Television Studios",
			"High Bridge Productions",
			"Gran Via Productions",
			"High Bridge Entertainment",
			"Sony Pictures Television",
		],
		networks: ["AMC", "Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Planet Earth II",
		description:
			"David Attenborough presents a documentary series exploring how animals meet the challenges of surviving in the most iconic habitats on earth.",
		tagline: "",
		year: "2016",
		release_date: "2016-11-06",
		imdb_id: "tt5491994",
		imdb_rating: "8",
		vote_count: "2",
		popularity: "1.775",
		youtube_trailer_key: "92bmDq2h92Q",
		rated: "U",
		runtime: 300,
		genres: ["Documentary"],
		stars: ["David Attenborough"],
		directors: ["Alistair Fothergill", "N/A"],
		countries: ["UK"],
		language: ["English"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Planet Earth",
		description:
			"Each 50 minute episode features a global overview of a different biome or habitat on Earth (Polar, Mountain, Cave, Desert, Plains, Fresh Water, Seas, Ocean, Forest), followed by a ten-minute featurette which takes a behind-the-scenes look at the challenges of filming the episode.",
		tagline: null,
		year: "2006",
		release_date: "0000-00-00",
		imdb_id: "tt0795176",
		imdb_rating: "0",
		vote_count: "0",
		popularity: "0",
		youtube_trailer_key: "I8Az_IIgw4U",
		rated: null,
		runtime: 538,
		genres: ["Documentary", "Family"],
		stars: ["Sigourney Weaver", "David Attenborough"],
		directors: null,
		countries: null,
		language: ["en"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Band of Brothers",
		description:
			"Drawn from interviews with survivors of Easy Company, as well as their journals and letters, Band of Brothers chronicles the experiences of these men from paratrooper training in Georgia through the end of the war. As an elite rifle company parachuting into Normandy early on D-Day morning, participants in the Battle of the Bulge, and witness to the horrors of war, the men of Easy knew extraordinary bravery and extraordinary fear - and became the stuff of legend. Based on Stephen E. Ambrose's acclaimed book of the same name.",
		release_date: "2001-09-09",
		imdb_id: "tt0185906",
		imdb_rating: "8.529",
		vote_count: "3385",
		popularity: "184.385",
		youtube_trailer_key: "KKRBAFlN5ww",
		rated: "TV-MA",
		runtime: 60,
		year_started: 2001,
		genres: ["Drama", "War", "Action", "Adventure", "History", "Mini-Series"],
		stars: [
			"Damian Lewis",
			"Donnie Wahlberg",
			"David Schwimmer",
			"Eion Bailey",
			"Ron Livingston",
			"Matthew Settle",
			"Michael Cudlitz",
			"Neal McDonough",
			"Scott Grimes",
			"Shane Taylor",
			"Ross McCall",
			"Frank John Hughes",
		],
		creators: ["Steven Spielberg", "Tom Hanks", "David Frankel", "Mikael Salomon"],
		countries: ["USA", "UK"],
		language: ["de", "fr", "lt", "nl", "en", "English, Dutch, French, German, Lithuanian"],
		production_companies: [
			"HBO Films",
			"DreamWorks Television",
			"DreamWorks Pictures",
			"BBC Television Centre",
			"Playtone",
			"HBO",
		],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Chernobyl",
		description:
			"In April 1986, an explosion at the Chernobyl nuclear power plant in the Union of Soviet Socialist Republics becomes one of the world's worst man-made catastrophes.",
		tagline: "",
		year: "2019",
		release_date: "0000-00-00",
		imdb_id: "tt7366338",
		imdb_rating: "9.4",
		vote_count: "584223",
		popularity: "0",
		youtube_trailer_key: "s9APLXM9Ei8",
		rated: "5h 30min                          ",
		runtime: 300,
		genres: ["Drama", "History", "Thriller"],
		stars: ["Jessie Buckley", "Jared Harris", "Stellan Skarsg\u00e5rd"],
		directors: null,
		countries: null,
		language: null,
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Wire",
		description:
			"The Wire follows a ragtag task force assembled by the Baltimore Police Department to investigate a local drug kingpin suspected of multiple homicides. As the case expands, it illuminates the systemic malaise and corruption plaguing the city's various public institutions",
		tagline: null,
		year: "2002",
		release_date: "0000-00-00",
		imdb_id: "tt0306414",
		imdb_rating: "5.5",
		vote_count: "2",
		popularity: "1.96",
		youtube_trailer_key: "apZQlqPp6Hs",
		rated: null,
		runtime: 90,
		genres: ["Crime", "Action", "Drama", "Mystery"],
		stars: [
			"Dominic West",
			"Lance Reddick",
			"Idris Elba",
			"Wood Harris",
			"Michael Kenneth Williams",
			"Sonja Sohn",
			"Wendell Pierce",
			"John Doman",
			"J.D. Williams",
			"Deirdre Lovejoy",
			"Clarke Peters",
			"Andre Royo",
			"Jim True-Frost",
			"Jamie Hector",
			"Gbenga Akinnagbe",
			"Michael B. Jordan",
			"Aidan Gillen",
			"Chris Bauer",
			"Tristan Mack Wilds",
			"Lawrence Gilliard Jr.",
			"Seth Gilliam",
			"Domenick Lombardozzi",
			"Frankie Faison",
			"Corey Parker Robinson",
			"Delaney Williams",
			"Robert Wisdom",
			"Anwan Glover",
			"Felicia Pearson",
			"Chad L. Coleman",
			"Tray Chaney",
			"Robert F. Chew",
			"Jermaine Crawford",
			"Hassan Johnson",
			"Paul Ben-Victor",
			"Method Man",
		],
		directors: ["David Simon"],
		countries: null,
		language: null,
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Avatar: The Last Airbender",
		description:
			"In a war-torn world of elemental magic, a young boy reawakens to undertake a dangerous mystic quest to fulfill his destiny as the Avatar, and bring peace to the world.",
		tagline: "Water. Earth. Fire. Air.",
		year: "2005",
		release_date: "0000-00-00",
		imdb_id: "tt0417299",
		imdb_rating: "10",
		vote_count: "18",
		popularity: "0",
		youtube_trailer_key: "ooVvH2IYz0w",
		rated: "PG",
		runtime: 23,
		genres: ["Animation", "Fantasy", "Adventure", "Action", "Comedy", "War"],
		stars: [
			"Zach Tyler",
			"Mae Whitman",
			"Jack De Sena",
			"Dante Basco",
			"Michaela Jill Murphy",
			"Mako",
			"Greg Baldwin",
			"Grey DeLisle",
			"Dee Bradley Baker",
			"Cricket Leigh",
			"Olivia Hack",
			"Mark Hamill",
			"Jessie Flower",
			"Jennie Kwan",
			"James Garrett",
			"Jason Isaacs",
			"James Sie",
			"Victor Brandt",
		],
		directors: ["Ethan Spaulding", "Lauren MacMullan", "Giancarlo Volpe", "N/A"],
		countries: ["USA"],
		language: ["English"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Blue Planet II",
		description:
			"David Attenborough returns to the world's oceans in this sequel to the acclaimed documentary filming rare and unusual creatures of the deep, as well as documenting the problems our oceans face.",
		tagline: null,
		year: "2017",
		release_date: "0000-00-00",
		imdb_id: "tt6769208",
		imdb_rating: "9",
		vote_count: "9",
		popularity: "0.6",
		youtube_trailer_key: "kAphgHhlteM",
		rated: null,
		runtime: 60,
		genres: ["Documentary"],
		stars: null,
		directors: null,
		countries: null,
		language: ["Nederlands", "English"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Sopranos",
		description:
			"The story of New Jersey-based Italian-American mobster Tony Soprano and the difficulties he faces as he tries to balance the conflicting requirements of his home life and the criminal organization he heads. Those difficulties are often highlighted through his ongoing professional relationship with psychiatrist Jennifer Melfi. The show features Tony's family members and Mafia associates in prominent roles and story arcs, most notably his wife Carmela and his cousin and prot\u00e9g\u00e9 Christopher Moltisanti.",
		release_date: "1999-01-10",
		imdb_id: "tt0141842",
		imdb_rating: "8.642",
		vote_count: "2561",
		popularity: "470.564",
		youtube_trailer_key: "KMx4iFcozK0",
		rated: "TV-MA",
		runtime: 55,
		year_started: 1999,
		genres: ["Drama", "Crime", "Family"],
		stars: [
			"James Gandolfini",
			"Edie Falco",
			"Jamie-Lynn Sigler",
			"Robert Iler",
			"Lorraine Bracco",
			"Michael Imperioli",
			"Steven Van Zandt",
			"Tony Sirico",
			"Dominic Chianese",
			"Aida Turturro",
			"Steve Schirripa",
			"Danielle Di Vecchio",
		],
		creators: ["David Chase", "Timothy Van Patten", "John Patterson", "Allen Coulter"],
		countries: ["USA"],
		language: ["en", "English, Italian, Russian"],
		production_companies: ["HBO"],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Cosmos",
		description:
			"Famed astrophysicist Neil deGrasse Tyson provides clarity for the vision of the cosmos as he voyages across the universe with never-before-told stories that delve into the scientific concepts of the laws of gravity and the origins of space and time.",
		release_date: "2014-03-09",
		imdb_id: "tt2395695",
		imdb_rating: "8.457",
		vote_count: "1456",
		popularity: "345.856",
		youtube_trailer_key: "_erVOAbz420",
		rated: "TV-G",
		runtime: 60,
		year_started: 2014,
		genres: ["Documentary"],
		stars: [
			"Neil deGrasse Tyson",
			"Stoney Emshwiller",
			"Piotr Michael",
			"Andr\u00e9 Sogliuzzo",
			"Phil LaMarr",
			"Seth MacFarlane",
			"John Steven Rocha",
			"Alfred Molina",
			"Paul Telfer",
			"Kenn Ashe",
			"Michael Chochol",
			"Kirsten Dunst",
		],
		creators: ["Ann Druyan", "Steven Soter", "Brannon Braga", "Bill Pope"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["Fuzzy Door Productions", "Cosmos Studios"],
		networks: ["FOX", "National Geographic", "FOX (US)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Our Planet",
		description:
			"Experience our planet's natural beauty and examine how climate change impacts all living creatures in this ambitious documentary of spectacular scope.",
		release_date: "2019-04-05",
		imdb_id: "tt9253866",
		imdb_rating: "8.537",
		vote_count: "328",
		popularity: "81.675",
		youtube_trailer_key: "aETNYyrqNYE",
		rated: "TV-PG",
		runtime: 50,
		year_started: 2019,
		genres: ["Documentary", "Action", "Adventure", "Family", "Mini-Series"],
		stars: ["David Attenborough", "Jacques Frantz"],
		creators: null,
		countries: ["UK"],
		language: ["en"],
		production_companies: ["Silverback Films", "WWF-UK", "World Wide Fund for Nature"],
		networks: ["Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Game of Thrones",
		description:
			"Seven noble families fight for control of the mythical land of Westeros. Friction between the houses leads to full-scale war. All while a very ancient evil awakens in the farthest north. Amidst the war, a neglected military order of misfits, the Night's Watch, is all that stands between the realms of men and icy horrors beyond.",
		release_date: "2011-04-17",
		imdb_id: "tt0944947",
		imdb_rating: "8.45",
		vote_count: "23246",
		popularity: "1242.52",
		youtube_trailer_key: "KPLWWIOCOOQ",
		rated: "TV-MA",
		runtime: 57,
		year_started: 2011,
		genres: ["Fantasy", "Sci-Fi", "Drama", "Action", "Adventure", "Mystery", "War", "Sci-Fi"],
		stars: [
			"Peter Dinklage",
			"Kit Harington",
			"Nikolaj Coster-Waldau",
			"Lena Headey",
			"Emilia Clarke",
			"Liam Cunningham",
			"Maisie Williams",
			"Isaac Hempstead-Wright",
			"Sophie Turner",
			"John Bradley",
			"Gwendoline Christie",
			"Jacob Anderson",
		],
		creators: ["David Benioff", "D. B. Weiss", "D.B. Weiss", "David Nutter", "Alan Taylor", "Alex Graves"],
		countries: ["USA"],
		language: ["en", "es", "de", "English"],
		production_companies: [
			"Revolution Sun Studios",
			"Television 360",
			"Generator Entertainment",
			"Bighead Littlehead",
		],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The World at War",
		description:
			"A documentary series that gives a historical account of the events of World War II, from its roots in the 1920s to the aftermath and the lives it profoundly influenced.",
		release_date: "1973-10-31",
		imdb_id: "tt0071075",
		imdb_rating: "8.1",
		vote_count: "140",
		popularity: "126.968",
		youtube_trailer_key: "0b4g4ZZNC1E",
		rated: "TV-PG",
		runtime: 60,
		year_started: 1973,
		genres: ["Documentary", "War", "History", "Mini-Series", "Drama", "Special Interest"],
		stars: [
			"Laurence Olivier",
			"Anthony Eden",
			"Averell Harriman",
			"Albert Speer",
			"Siegfried Westphal",
			"J. Lawton Collins",
			"Lawrence Durrell",
			"Toshikazu Kase",
			"Louis Mountbatten",
			"Wynford Vaughan-Thomas",
			"David Belchem",
			"Christabel Bielenberg",
		],
		creators: ["Jeremy Isaacs", "Hugh Raggett", "John Pett", "David Elstein"],
		countries: ["UK"],
		language: ["fr", "de", "en", "English, German, French, Japanese"],
		production_companies: ["FremantleMedia", "Thames Television", "Blakeway Productions"],
		networks: ["ITV1", "ITV"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Bluey",
		description:
			"Bluey is an inexhaustible six year-old Blue Heeler dog, who loves to play and turns everyday family life into extraordinary adventures, developing her imagination as well as her mental, physical and emotional resilience.",
		release_date: "2018-10-01",
		imdb_id: "tt7678620",
		imdb_rating: "8.637",
		vote_count: "474",
		popularity: "616.76",
		youtube_trailer_key: "vDVFk56PTd8",
		rated: "TV-Y",
		runtime: 7,
		year_started: 2018,
		genres: ["Animation", "Kids", "Comedy", "Children", "Family", "Short"],
		stars: ["Dave McCormack", "Melanie Zanetti", "David McCormack", "Charlotte Stent"],
		creators: ["Joe Brumm"],
		countries: ["AU", "Au"],
		language: ["en"],
		production_companies: [
			"Ludo Studio",
			"Australian Broadcasting Corporation",
			"Screen Australia",
			"Screen Queensland",
			"CBeebies",
			"BBC Worldwide",
			"BBC Studios Distribution",
		],
		networks: ["ABC Kids", "ABC KIDS"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Fullmetal Alchemist: Brotherhood",
		description:
			"Disregard for alchemy\u2019s laws ripped half of Edward Elric\u2019s limbs from his body and left his brother Alphonse\u2019s soul clinging to a suit of armor. To restore what was lost, the brothers seek the Philosopher\u2019s Stone. Enemies and allies \u2013 the corrupt military, the Homunculi, and foreign alchemists \u2013 will alter the Elric brothers course, but their purpose will remain unchanged and their bond unbreakable.",
		release_date: "2009-04-05",
		imdb_id: "tt1355642",
		imdb_rating: "8.695",
		vote_count: "1919",
		popularity: "2221.06",
		youtube_trailer_key: "GoNo0DGroU",
		rated: "TV-14",
		runtime: 25,
		year_started: 2009,
		genres: ["Action", "Adventure", "Animation", "Fantasy", "Sci-Fi", "Comedy", "Drama", "Anime", "Mystery"],
		stars: [
			"Romi Park",
			"Rie Kugimiya",
			"Shin-ichiro Miki",
			"Fumiko Orikasa",
			"Megumi Takamoto",
			"Kenta Miyake",
			"Hidekatsu Shibata",
			"Mamoru Miyano",
			"Kenji Utsumi",
			"Biichi Satoh",
			"Kent Williams",
			"Iemasa Kayumi",
		],
		creators: ["Yasuhiro Irie", "Hiromu Arakawa", "Tsutomu Yabuki", "Kiyomitsu Sato"],
		countries: ["JP", "Jp"],
		language: ["ja", "en", "Japanese"],
		production_companies: ["BONES", "Aniplex", "Square Enix", "MBS", "Techno Sound"],
		networks: [
			"MBS",
			"TBS",
			"CBC",
			"SBS",
			"Shizuoka Broadcasting System",
			"TBS (JP)",
			"SBS TV",
			"ANIMAX",
			"JNN",
			"Rakuten TV",
			"Adult Swim",
			"Tokyo Broadcasting System",
			"Animax",
			"Funimation Channel",
		],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Rick and Morty",
		description:
			"Rick is a mentally-unbalanced but scientifically gifted old man who has recently reconnected with his family. He spends most of his time involving his young grandson Morty in dangerous, outlandish adventures throughout space and alternate universes. Compounded with Morty's already unstable family life, these events cause Morty much distress at home and school.",
		release_date: "2013-12-02",
		imdb_id: "tt2861424",
		imdb_rating: "8.698",
		vote_count: "9370",
		popularity: "877.464",
		youtube_trailer_key: "hl1U0bxTHbY",
		rated: "TV-14",
		runtime: 22,
		year_started: 2013,
		genres: ["Animation", "Comedy", "Fantasy", "Sci-Fi", "Action", "Adventure", "Sci-Fi"],
		stars: [
			"Chris Parnell",
			"Spencer Grammer",
			"Sarah Chalke",
			"Ian Cardoni",
			"Harry Belden",
			"Justin Roiland",
			"Kari Wahlgren",
			"Tom Kenny",
			"Ryan Ridley",
			"Maurice LaMarche",
			"Brandon Johnson",
			"Dan Harmon",
		],
		creators: ["Justin Roiland", "Dan Harmon", "Pete Michels", "Wesley Archer", "Bryan Newton"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Williams Street",
			"Harmonious Claptrap",
			"Justin Roiland's Solo Vanity Card Productions",
			"Starburns Industries",
			"Green Portal Productions",
			"Harmonius Claptrap",
		],
		networks: ["Adult Swim"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Life",
		description:
			"David Attenborough looks at the extraordinary ends to which animals and plants go in order to survive. Featuring epic spectacles, amazing TV firsts and examples of new wildlife behaviour.",
		release_date: "2009-10-11",
		imdb_id: "tt1533395",
		imdb_rating: "8.3",
		vote_count: "326",
		popularity: "39.46",
		youtube_trailer_key: "LeLsJfGmY_Y",
		rated: "TV-G",
		runtime: 50,
		year_started: 2009,
		genres: ["Documentary"],
		stars: [
			"David Attenborough",
			"Oprah Winfrey",
			"Doug Allan",
			"Michael Pitts",
			"Jonathan Smith",
			"Doug Anderson",
			"David Baillie",
			"Simon Blakeney",
			"Barrie Britton",
			"Lincoln Brower",
			"Adam Chapman",
			"Mick Connaire",
		],
		creators: ["Martha Holmes"],
		countries: ["UK"],
		language: ["en", "English"],
		production_companies: ["BBC"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Last Dance",
		description:
			"A 10-part documentary chronicling the untold story of Michael Jordan and the Chicago Bulls dynasty with rare, never-before-seen footage and sound from the 1997-98 championship season \u2013 plus over 100 interviews with famous figures and basketball\u2019s biggest names.",
		release_date: "2020-04-19",
		imdb_id: "tt8420184",
		imdb_rating: "8.2",
		vote_count: "1207",
		popularity: "89.752",
		youtube_trailer_key: "N9Z9JtNcCWY",
		rated: "TV-MA",
		runtime: 50,
		year_started: 2020,
		genres: ["Documentary", "History", "Sport", "Biography", "Mini-Series"],
		stars: [
			"Michael Jordan",
			"Scottie Pippen",
			"Dennis Rodman",
			"Steve Kerr",
			"Phil Jackson",
			"David Aldridge",
			"Stephen Douglas Kerr",
		],
		creators: ["Michael Tollin", "Mike Tollin"],
		countries: ["USA"],
		language: ["en"],
		production_companies: ["ESPN Films", "Jump 23", "Mandalay Sports Media", "NBA Entertainment"],
		networks: ["ESPN", "Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Twilight Zone",
		description:
			"A series of unrelated stories containing drama, psychological thriller, fantasy, science fiction, suspense, and/or horror, often concluding with a macabre or unexpected twist.",
		release_date: "1959-10-02",
		imdb_id: "tt0052520",
		imdb_rating: "8.444",
		vote_count: "844",
		popularity: "463.109",
		youtube_trailer_key: "29_gA_GDGvE",
		rated: "TV-PG",
		runtime: 52,
		year_started: 1959,
		genres: ["Fantasy", "Sci-Fi", "Mystery", "Drama", "Horror", "Suspense", "Thriller", "Sci-Fi", "Comedy"],
		stars: [
			"Rod Serling",
			"Robert McCord",
			"Jay Overholts",
			"Vaughn Taylor",
			"James Turley",
			"Jack Klugman",
			"Burgess Meredith",
			"John Anderson",
			"J. Pat O'Malley",
			"Barney Phillips",
			"George Mitchell",
			"Cyril Delevanti",
		],
		creators: ["Rod Serling", "John Brahm", "Douglas Heyes", "Buzz Kulik"],
		countries: ["USA", "CA", "Ca"],
		language: ["en", "English"],
		production_companies: [
			"Cayuga Productions",
			"CBS Productions",
			"Columbia Broadcasting System (CBS)",
			"Genre Films",
			"Monkeypaw Productions",
			"New Line Television",
		],
		networks: ["CBS"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Sherlock",
		description:
			"A modern update finds the famous sleuth and his doctor partner solving crime in 21st century London.",
		release_date: "2010-07-25",
		imdb_id: "tt1475582",
		imdb_rating: "8.524",
		vote_count: "5071",
		popularity: "557.656",
		youtube_trailer_key: "IrBKwzL3K7s",
		rated: "TV-14",
		runtime: 90,
		year_started: 2010,
		genres: ["Crime", "Drama", "Mystery", "Suspense", "Thriller"],
		stars: [
			"Benedict Cumberbatch",
			"Martin Freeman",
			"Una Stubbs",
			"Rupert Graves",
			"Louise Brealey",
			"Mark Gatiss",
			"Andrew Scott",
			"Amanda Abbington",
			"Jonathan Aris",
			"Vinette Robinson",
			"Tanya Moodie",
			"Lindsay Duncan",
		],
		creators: ["Mark Gatiss", "Steven Moffat", "Paul McGuigan", "Nick Hurran", "Coky Giedroyc"],
		countries: ["UK"],
		language: ["en", "English"],
		production_companies: ["Hartswood Films", "BBC Cymru Wales", "Masterpiece", "BBC Wales"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Vietnam War",
		description:
			"An immersive 360-degree narrative telling the epic story of the Vietnam War as it has never before been told on film. Featuring testimony from nearly 80 witnesses, including many Americans who fought in the war and others who opposed it, as well as Vietnamese combatants and civilians from both the winning and losing sides.",
		release_date: "2017-09-17",
		imdb_id: "tt1877514",
		imdb_rating: "8.351",
		vote_count: "148",
		popularity: "78.506",
		youtube_trailer_key: "iWFzaUlZz-k",
		rated: "TV-MA",
		runtime: 990,
		year_started: 2017,
		genres: ["Documentary", "War", "History"],
		stars: [
			"Peter Coyote",
			"Huy Duc",
			"James Willbanks",
			"Duong Van Mai Elliott",
			"Karl Marlantes",
			"John Musgrave",
			"Nguyen Ngoc",
			"Bao Ninh",
			"Phan Quang Tue",
			"Carol Crocker",
			"Leslie Gelb",
			"Roger Harris",
		],
		creators: ["Ken Burns", "Lynn Novick"],
		countries: ["USA"],
		language: ["en", "de", "vi", "English"],
		production_companies: ["Florentine Films", "WETA", "ARTE"],
		networks: ["PBS"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Attack on Titan",
		description:
			"Several hundred years ago, humans were nearly exterminated by Titans. Titans are typically several stories tall, seem to have no intelligence, devour human beings and, worst of all, seem to do it for the pleasure rather than as a food source. A small percentage of humanity survived by walling themselves in a city protected by extremely high walls, even taller than the biggest Titans. Flash forward to the present and the city has not seen a Titan in over 100 years. Teenage boy Eren and his foster sister Mikasa witness something horrific as the city walls are destroyed by a Colossal Titan that appears out of thin air. As the smaller Titans flood the city, the two kids watch in horror as their mother is eaten alive. Eren vows that he will murder every single Titan and take revenge for all of mankind.",
		release_date: "2013-04-07",
		imdb_id: "tt2560140",
		imdb_rating: "8.664",
		vote_count: "6044",
		popularity: "244.054",
		youtube_trailer_key: "LV-nazLVmgo",
		rated: "TV-MA",
		runtime: 24,
		year_started: 2013,
		genres: [
			"Animation",
			"Fantasy",
			"Sci-Fi",
			"Action",
			"Adventure",
			"Anime",
			"Drama",
			"Horror",
			"War",
			"Mystery",
			"Sci-Fi",
		],
		stars: [
			"Yuki Kaji",
			"Yui Ishikawa",
			"Marina Inoue",
			"Kisho Taniyama",
			"Hiro Shimono",
			"Yoshimasa Hosoya",
			"Takehito Koyasu",
			"Ayane Sakura",
			"Natsuki Hanae",
			"Yu Kobayashi",
			"Romi Park",
			"Y\u016b Kobayashi",
		],
		creators: [
			"Yasuko Kobayashi",
			"Tetsuro Araki",
			"Hajime Isayama",
			"Masashi Koizuka",
			"Tetsur\u00f4 Araki",
			"Hiroyuki Tanaka",
		],
		countries: ["JP", "Jp"],
		language: ["ja", "en", "Japanese"],
		production_companies: [
			"Production I.G",
			"MAPPA",
			"WIT STUDIO",
			"Pony Canyon",
			"Techno Sound",
			"Kodansha",
			"dentsu",
			"MBS",
			"Pony Canyon Enterprise",
			"Studio Wanpack",
			"Studio Bihou",
			"Wit Studio",
			"WIT Studio",
		],
		networks: ["MBS", "NHK G", "Tokyo MX", "NHK", "NHK G\t", "HTB", "BS11", "FBS", "Netflix", "MBS TV"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Batman: The Animated Series",
		description:
			'Vowing to avenge the murder of his parents, Bruce Wayne devotes his life to wiping out crime in Gotham City as the masked vigilante "Batman".',
		release_date: "1992-09-05",
		imdb_id: "tt0103359",
		imdb_rating: "8.5",
		vote_count: "1531",
		popularity: "252.119",
		youtube_trailer_key: "rrmUk2YUm14",
		rated: "TV-PG",
		runtime: 22,
		year_started: 1992,
		genres: [
			"Action",
			"Adventure",
			"Animation",
			"Drama",
			"Mystery",
			"Superhero",
			"Crime",
			"Family",
			"Sci-Fi",
			"Thriller",
			"Children",
		],
		stars: [
			"Kevin Conroy",
			"Efrem Zimbalist Jr.",
			"Loren Lester",
			"Bob Hastings",
			"Efrem Zimbalist, Jr.",
			"Robert Hastings",
			"Mari Devon",
			"Robert Costanzo",
			"Mark Hamill",
			"Richard Moll",
			"Lloyd Bochner",
			"Arleen Sorkin",
		],
		creators: [
			"Bruce Timm",
			"Eric Radomski",
			"Bob Kane",
			"Tom Ruegger",
			"Jean MacCurdy",
			"Alan Burnett",
			"Kevin Altieri",
			"Boyd Kirkland",
			"Frank Paur",
		],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["DC Comics", "Warner Bros. Television"],
		networks: ["FOX", "Fox Kids", "FOX (US)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Office",
		description:
			"The everyday lives of office employees in the Scranton, Pennsylvania branch of the fictional Dunder Mifflin Paper Company.",
		release_date: "2005-03-24",
		imdb_id: "tt0386676",
		imdb_rating: "8.573",
		vote_count: "3940",
		popularity: "775.34",
		youtube_trailer_key: "tNcDHWpselE",
		rated: "TV-14",
		runtime: 24,
		year_started: 2005,
		genres: ["Comedy"],
		stars: [
			"Rainn Wilson",
			"John Krasinski",
			"Jenna Fischer",
			"Ed Helms",
			"B.J. Novak",
			"Steve Carell",
			"James Spader",
			"Ward Edmondson",
			"B. J. Novak",
			"Rashida Jones",
			"Angela Kinsey",
			"Brian Baumgartner",
		],
		creators: ["Ricky Gervais", "Stephen Merchant", "Greg Daniels", "Paul Feig", "Randall Einhorn", "Ken Kwapis"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Universal Television",
			"Deedle-Dee Productions",
			"Reveille Productions",
			"Shine America",
			"Universal Media Studios",
		],
		networks: ["NBC"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Blue Planet",
		description:
			"Sir David Attenborough narrates this critically acclaimed series that dives deep into the marine environment of Planet Earth. Although two-thirds of the world's surface is covered with water, scientists know less about the oceans than they do about the surface of the moon. This limited series travels from various coasts to the poles to examine watery denizens ranging from the gigantic blue whale to microscopic coral polyps.",
		release_date: "2001-09-12",
		imdb_id: "tt0296310",
		imdb_rating: "8.3",
		vote_count: "309",
		popularity: "66.562",
		youtube_trailer_key: "kAphgHhlteM&t=13s",
		rated: "0+",
		runtime: 51,
		year_started: 2001,
		genres: ["Documentary"],
		stars: ["David Attenborough", "Pierce Brosnan", "Jason Roberts"],
		creators: ["Alastair Fothergill", "Andy Byatt"],
		countries: ["UK"],
		language: ["en", "English"],
		production_companies: ["Discovery Channel", "BBC", "BBC Television Centre"],
		networks: ["BBC One", "BBC Television Centre"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Arcane",
		description:
			"Amid the stark discord of twin cities Piltover and Zaun, two sisters fight on rival sides of a war between magic technologies and clashing convictions.",
		release_date: "2021-11-06",
		imdb_id: "tt11126994",
		imdb_rating: "8.744",
		vote_count: "3738",
		popularity: "264.281",
		youtube_trailer_key: "fXmAurh012s",
		rated: "TV-14",
		runtime: 42,
		year_started: 2021,
		genres: ["Animation", "Drama", "Fantasy", "Sci-Fi", "Action", "Adventure"],
		stars: [
			"Hailee Steinfeld",
			"Ella Purnell",
			"Kevin Alejandro",
			"Jason Spisak",
			"Toks Olagundoye",
			"Harry Lloyd",
			"Katie Leung",
			"J. B. Blanc",
		],
		creators: ["Christian Linke", "Alex Yee"],
		countries: ["USA"],
		language: ["en"],
		production_companies: ["Fortiche Production", "Riot Games"],
		networks: ["Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Scam 1992: The Harshad Mehta Story",
		description:
			"Set in 1980's & 90's Bombay, Scam 1992 follows the life of Harshad Mehta - a stockbroker who single-handedly took the stock market to dizzying heights & his catastrophic downfall. Being directed by National Award-winning filmmaker Hansal Mehta, the series is based on journalist Debashis Basu & Sucheta Dalal's book \"The Scam\".",
		release_date: "2020-10-08",
		imdb_id: "tt12392504",
		imdb_rating: "9",
		vote_count: "13",
		popularity: "62.95",
		youtube_trailer_key: "1faUIRDYSXo",
		rated: "TV-14     ",
		runtime: 55,
		year_started: 2020,
		genres: ["Crime", "Drama", "Biography"],
		stars: [
			"Pratik Gandhi",
			"Shreya Dhanwanthary",
			"Anjali Barot",
			"Hemant Kher",
			"Chirag Vohra",
			"Jay Upadhayay",
			"Satish Kaushik",
			"K.K. Raina",
			"Ramakant Dayma",
			"Kumkum Das",
			"Rajat Kapoor",
			"Sharib Hashmi",
		],
		creators: ["Hansal Mehta"],
		countries: ["IN", "In"],
		language: ["en", "gu", "hi", "ta"],
		production_companies: ["Applause Entertainment"],
		networks: ["Sony Liv"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Better Call Saul",
		description:
			'Six years before Saul Goodman meets Walter White. We meet him when the man who will become Saul Goodman is known as Jimmy McGill, a small-time lawyer searching for his destiny, and, more immediately, hustling to make ends meet. Working alongside, and, often, against Jimmy, is \u201cfixer\u201d Mike Ehrmantraut. The series tracks Jimmy\u2019s transformation into Saul Goodman, the man who puts \u201ccriminal\u201d in \u201ccriminal lawyer".',
		release_date: "2015-02-08",
		imdb_id: "tt3032476",
		imdb_rating: "8.675",
		vote_count: "4900",
		popularity: "714.172",
		youtube_trailer_key: "HN4oydykJFc",
		rated: "TV-MA",
		runtime: 42,
		year_started: 2015,
		genres: ["Crime", "Drama", "Romance", "Comedy"],
		stars: [
			"Bob Odenkirk",
			"Jonathan Banks",
			"Rhea Seehorn",
			"Patrick Fabian",
			"Michael Mando",
			"Tony Dalton",
			"Giancarlo Esposito",
			"Michael McKean",
			"Mark Margolis",
			"Kerry Condon",
			"Brandon K. Hampton",
			"Vincent Fuentes",
		],
		creators: ["Peter Gould", "Vince Gilligan", "Thomas Schnauz", "Adam Bernstein"],
		countries: ["USA"],
		language: ["en", "de", "es", "English, Spanish, Vietnamese"],
		production_companies: [
			"Sony Pictures Television Studios",
			"Gran Via Productions",
			"High Bridge Productions",
			"Crystal Diner",
			"Sony Pictures Television",
			"AMC Networks",
		],
		networks: ["AMC"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Clarkson's Farm",
		description:
			"Follow Jeremy Clarkson as he embarks on his latest adventure, farming. The man who on several occasions claims to be allergic to manual labour takes on the most manually labour intensive job there is. What could possibly go wrong?",
		release_date: "2021-06-11",
		imdb_id: "tt10541088",
		imdb_rating: "8.391",
		vote_count: "211",
		popularity: "324.686",
		youtube_trailer_key: "pW-iVG0_D34",
		rated: "TV-PG",
		runtime: 50,
		year_started: 2021,
		genres: ["Reality-TV", "Comedy", "Reality", "Adventure", "Documentary"],
		stars: ["Jeremy Clarkson", "Kaleb Cooper", "Charlie Ireland", "Lisa Hogan"],
		creators: ["Jeremy Clarkson"],
		countries: ["UK"],
		language: ["en"],
		production_companies: ["Expectation Entertainment", "Con Dao Productions"],
		networks: ["Prime Video", "Amazon"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Human Planet",
		description:
			"A cinematic experience bringing you the most amazing human stories in the world. Humans and wildlife surviving in the most extreme environments on Earth.",
		release_date: "2011-01-13",
		imdb_id: "tt1806234",
		imdb_rating: "8.4",
		vote_count: "133",
		popularity: "7.482",
		youtube_trailer_key: "GmfvOEjXWe4",
		rated: "TP",
		runtime: 50,
		year_started: 2011,
		genres: ["Documentary"],
		stars: ["John Hurt", "Roger Munns"],
		creators: ["Brian Leith", "Dale Templar", "Mark Flowers", "Nicolas Brown", "Tom Hugh-Jones"],
		countries: ["UK"],
		language: ["en", "English"],
		production_companies: ["France T\u00e9l\u00e9visions"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Frozen Planet",
		description:
			"David Attenborough travels to the end of the earth, taking viewers on an extraordinary journey across the polar regions of our planet.",
		release_date: "2011-10-26",
		imdb_id: "tt2092588",
		imdb_rating: "8.313",
		vote_count: "243",
		popularity: "56.294",
		youtube_trailer_key: "yNiBL8Jok4s",
		rated: "TV-PG",
		runtime: 50,
		year_started: 2011,
		genres: ["Documentary"],
		stars: [
			"David Attenborough",
			"Alec Baldwin",
			"Chadden Hunter",
			"Ted Giffords",
			"John Aitchison",
			"Doug Allan",
			"Doug Anderson",
			"Miles Barton",
			"Vanessa Berlowitz",
			"Lewis Brower",
			"John Durban",
			"Faye Hicks",
		],
		creators: ["David Attenborough"],
		countries: ["UK"],
		language: ["en", "fr", "English, Russian"],
		production_companies: ["BBC", "Discovery Channel", "Atresmedia", "ZDF", "Skai", "The Open University"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Firefly",
		description:
			'In the year 2517, after the arrival of humans in a new star system, follow the adventures of the renegade crew of Serenity, a "Firefly-class" spaceship. The ensemble cast portrays the nine characters who live on Serenity.',
		release_date: "2002-09-20",
		imdb_id: "tt0303461",
		imdb_rating: "8.329",
		vote_count: "1932",
		popularity: "113.502",
		youtube_trailer_key: "oBZrZij2-g8",
		rated: "TV-14",
		runtime: 86,
		year_started: 2002,
		genres: ["Drama", "Action", "Adventure", "Fantasy", "Sci-Fi", "Sci-Fi", "Western"],
		stars: [
			"Nathan Fillion",
			"Gina Torres",
			"Alan Tudyk",
			"Morena Baccarin",
			"Adam Baldwin",
			"Jewel Staite",
			"Sean Maher",
			"Summer Glau",
			"Ron Glass",
			"Christina Hendricks",
			"Mark Sheppard",
			"Michael Fairman",
		],
		creators: ["Joss Whedon", "Vern Gillum", "Tim Minear"],
		countries: ["USA"],
		language: ["en", "English, Mandarin"],
		production_companies: ["Mutant Enemy Productions", "20th Century Fox Television"],
		networks: ["FOX", "FOX (US)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Hunter x Hunter",
		description:
			"Twelve-year-old Gon Freecss one day discovers that the father he had always been told was dead was alive. His Father, Ging, is a Hunter \u2014 a member of society's elite with a license to go anywhere or do almost anything. Gon, determined to follow in his father's footsteps, decides to take the Hunter Examination and eventually find his father to prove himself as a Hunter in his own right. But on the way, he learns that there is more to becoming a Hunter than previously thought, and the challenges that he must face are considered the toughest in the world.",
		release_date: "2011-10-02",
		imdb_id: "tt2098220",
		imdb_rating: "8.619",
		vote_count: "1638",
		popularity: "859.827",
		youtube_trailer_key: "d6kBeJjTGnY",
		rated: "TV-14",
		runtime: 24,
		year_started: 2011,
		genres: ["Animation", "Action", "Adventure", "Fantasy", "Sci-Fi", "Anime", "Comedy", "Drama"],
		stars: [
			"Megumi Han",
			"Mariya Ise",
			"Issei Futamata",
			"Miyuki Sawashiro",
			"Keiji Fujiwara",
			"Daisuke Namikawa",
			"Banjo Ginga",
			"Rikiya Koyama",
			"Chisa Yokoyama",
			"Koki Uchiyama",
			"Mamoru Miyano",
			"Banjou Ginga",
		],
		creators: ["Yoshihiro Togashi", "Hiroshi K\u00f4jina", "Tony Oliver"],
		countries: ["JP", "Jp"],
		language: ["ja", "en", "Japanese"],
		production_companies: ["Madhouse", "Madhouse Productions"],
		networks: ["Nippon TV", "NTV", "NIPPON TV", "NTV (JP)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Only Fools and Horses",
		description:
			"The misadventures of two wheeler dealer brothers Del Boy and Rodney Trotter of 'Trotters Independent Traders PLC' who scrape their living by selling dodgy goods believing that next year they will be millionaires.",
		release_date: "1981-09-08",
		imdb_id: "tt0081912",
		imdb_rating: "7.927",
		vote_count: "248",
		popularity: "107.515",
		youtube_trailer_key: "Y7Doa6Aei4M",
		rated: "TV-PG",
		runtime: 50,
		year_started: 1981,
		genres: ["Comedy"],
		stars: [
			"David Jason",
			"Nicholas Lyndhurst",
			"Buster Merryfield",
			"Gwyneth Strong",
			"Tessa Peake-Jones",
			"Patrick Murray",
			"Sue Holderness",
			"Roger Lloyd Pack",
			"John Challis",
			"Lennard Pearce",
			"Kenneth MacDonald",
			"Paul Barber",
		],
		creators: ["John Sullivan", "Tony Dow", "Ray Butt", "Susan Belbin"],
		countries: ["UK"],
		language: ["en", "vi", "English"],
		production_companies: ["BBC"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Civil War",
		description: "A comprehensive and definitive history of the American Civil War.",
		release_date: "1990-09-23",
		imdb_id: "tt0098769",
		imdb_rating: "8.7",
		vote_count: "51",
		popularity: "6.14",
		youtube_trailer_key: "Y7HmBmWz9mI",
		rated: "TV-14",
		runtime: 70,
		year_started: 1990,
		genres: ["Documentary", "War", "History", "Special-interest"],
		stars: [
			"Sam Waterston",
			"Morgan Freeman",
			"Jason Robards",
			"Shelby Foote",
			"Garrison Keillor",
			"Arthur Miller",
			"Jeremy Irons",
			"Julie Harris",
			"David McCullough",
			"Paul Roebling",
			"George Plimpton",
			"Horton Foote",
		],
		creators: ["Ken Burns"],
		countries: ["USA"],
		language: ["en", "de", "English"],
		production_companies: [
			"Florentine Films",
			"American Documentaries Inc.",
			"Kenneth Lauren Burns",
			"WETA",
			"Time-Life Video",
		],
		networks: ["PBS"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Death Note",
		description:
			"Light Yagami is an ace student with great prospects\u2014and he\u2019s bored out of his mind. But all that changes when he finds the Death Note, a notebook dropped by a rogue Shinigami death god. Any human whose name is written in the notebook dies, and Light has vowed to use the power of the Death Note to rid the world of evil. But will Light succeed in his noble goal, or will the Death Note turn him into the very thing he fights against?",
		release_date: "2006-10-04",
		imdb_id: "tt0877057",
		imdb_rating: "8.638",
		vote_count: "3946",
		popularity: "447.754",
		youtube_trailer_key: "NlJZ-YgAt-c",
		rated: "TV-MA",
		runtime: 22,
		year_started: 2006,
		genres: [
			"Animation",
			"Mystery",
			"Fantasy",
			"Sci-Fi",
			"Anime",
			"Horror",
			"Suspense",
			"Crime",
			"Thriller",
			"Drama",
		],
		stars: [
			"Mamoru Miyano",
			"Shido Nakamura",
			"Aya Hirano",
			"Kappei Yamaguchi",
			"Kimiko Saito",
			"Naoya Uchida",
			"Ryou Naitou",
			"Keiji Fujiwara",
			"Kazuya Nakai",
			"Noriko Hidaka",
			"Shid\u00f4 Nakamura",
			"Nozomu Sasaki",
		],
		creators: ["Tetsur\u00f4 Araki", "Tomohiko It\u00f4", "Hiroyuki Tsuchiya"],
		countries: ["JP", "Jp"],
		language: ["ja", "en", "Japanese"],
		production_companies: ["Madhouse"],
		networks: ["Nippon TV", "NTV", "NTV (JP)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Seinfeld",
		description:
			"A stand-up comedian and his three offbeat friends weather the pitfalls and payoffs of life in New York City in the '90s. It's a show about nothing.",
		release_date: "1989-07-05",
		imdb_id: "tt0098904",
		imdb_rating: "8.288",
		vote_count: "1766",
		popularity: "2192.63",
		youtube_trailer_key: "hQXKyIG_NS4",
		rated: "TV-PG",
		runtime: 22,
		year_started: 1989,
		genres: ["Comedy"],
		stars: [
			"Jerry Seinfeld",
			"Jason Alexander",
			"Michael Richards",
			"Julia Louis-Dreyfus",
			"Ruth Cohen",
			"Wayne Knight",
			"Norman Brenner",
			"Heidi Swedberg",
			"Estelle Harris",
			"Jerry Stiller",
			"Liz Sheridan",
			"John O'Hurley",
		],
		creators: ["Jerry Seinfeld", "Larry David", "Andy Ackerman", "Tom Cherones", "David Steinberg"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Castle Rock Entertainment",
			"West/Shapiro Productions",
			"Fred Barron Productions",
			"Giggling Goose Productions",
			"Columbia TriStar Television",
			"West-Shapiro",
		],
		networks: ["NBC", "HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The Beatles: Get Back",
		description:
			"The three-part documentary series, compiled from over 60 hours of unseen footage, captures the warmth, camaraderie, and creative genius that defined the legacy of music\u2019s most iconic foursome. The series also includes \u2013 for the first time in its entirety \u2013 The Beatles\u2019 final performance at London\u2019s Savile Row.",
		release_date: "2021-11-25",
		imdb_id: "tt9735318",
		imdb_rating: "8.443",
		vote_count: "326",
		popularity: "30.403",
		youtube_trailer_key: "Auta2lagtw4",
		rated: "TV-14",
		runtime: 138,
		year_started: 2021,
		genres: ["Documentary", "Mini-Series", "Musical"],
		stars: [
			"John Lennon",
			"Paul McCartney",
			"George Harrison",
			"Ringo Starr",
			"Billy Preston",
			"George Martin",
			"Michael Lindsay-Hogg",
			"Glyn Johns",
			"Mal Evans",
			"Yoko Ono",
			"Geoff Emerick",
			"Heather McCartney",
		],
		creators: ["Peter Jackson"],
		countries: ["NZ", "UK", "USA", "Nz"],
		language: ["en"],
		production_companies: ["WingNut Films", "Apple Corps", "Walt Disney Pictures", "Polygram Entertainment"],
		networks: ["Disney+"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Dekalog",
		description:
			"Originally made for Polish television, \u201cThe Decalogue\u201d focuses on the residents of a housing complex in late-Communist Poland, whose lives become subtly intertwined as they face emotional dilemmas that are at once deeply personal and universally human. Its ten hour-long films, drawing from the Ten Commandments for thematic inspiration and an overarching structure, grapple deftly with complex moral and existential questions concerning life, death, love, hate, truth, and the passage of time.",
		release_date: "1989-12-10",
		imdb_id: "tt0092337",
		imdb_rating: "8.8",
		vote_count: "47",
		popularity: "8.432",
		youtube_trailer_key: "OYg5zswGG8Y",
		rated: "TV-MA",
		runtime: 55,
		year_started: 1989,
		genres: ["Drama"],
		stars: [
			"Artur Barci\u015b",
			"Olgierd \u0141ukaszewicz",
			"Olaf Lubaszenko",
			"Krystyna Janda",
			"Aleksander Bardini",
			"Henryk Baranowski",
			"Piotr Machalica",
			"Jerzy Stuhr",
			"Stanis\u0142aw Gawlik",
			"Zbigniew Zamachowski",
			"Artur Barcis",
			"Olgierd Lukaszewicz",
		],
		creators: ["Krzysztof Kie\u015blowski", "Krzysztof Piesiewicz", "Krzysztof Kieslowski"],
		countries: ["PL", "Pl"],
		language: ["pl", "Polish"],
		production_companies: ["Sender Freies Berlin", 'Zesp\u00f3l Filmowy "Tor"', "TVP", "Studio Filmowe Tor"],
		networks: ["TVP1"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Gravity Falls",
		description:
			"Twin brother and sister Dipper and Mabel Pines are in for an unexpected adventure when they spend the summer helping their great uncle Stan run a tourist trap in the mysterious town of Gravity Falls, Oregon.",
		release_date: "2012-06-15",
		imdb_id: "tt1865718",
		imdb_rating: "8.4",
		vote_count: "1804",
		popularity: "226.538",
		youtube_trailer_key: "yfUDIPUETUg",
		rated: "TV-Y7",
		runtime: 22,
		year_started: 2012,
		genres: [
			"Animation",
			"Comedy",
			"Mystery",
			"Fantasy",
			"Sci-Fi",
			"Kids",
			"Adventure",
			"Action",
			"Family",
			"Sci-Fi",
		],
		stars: [
			"Kristen Schaal",
			"Linda Cardellini",
			"Jason Ritter",
			"Alex Hirsch",
			"Jessica DiCicco",
			"Jennifer Coolidge",
			"Thurop Van Orman",
			"Stephen Root",
			"Dee Bradley Baker",
			"Frank Welker",
			"Jackie Buscarino",
			"Keith Ferguson",
		],
		creators: ["Alex Hirsch", "Joe Pitt", "John Aoshima", "Matt Braly"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["Disney Television Animation"],
		networks: ["Disney XD", "Disney Channel", "Discovery Shed"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "True Detective",
		description:
			"An American anthology police detective series utilizing multiple timelines in which investigations seem to unearth personal and professional secrets of those involved, both within or outside the law.",
		release_date: "2014-01-12",
		imdb_id: "tt2356777",
		imdb_rating: "8.3",
		vote_count: "3197",
		popularity: "1538.86",
		youtube_trailer_key: "fVQUcaO4AvE",
		rated: "TV-MA",
		runtime: 60,
		year_started: 2014,
		genres: ["Drama", "Crime", "Mystery", "Thriller"],
		stars: [
			"Jodie Foster",
			"Kali Reis",
			"Fiona Shaw",
			"Finn Bennett",
			"Isabella Star LaBlanc",
			"Christopher Eccleston",
			"John Hawkes",
			"Matthew McConaughey",
			"Colin Farrell",
			"Mahershala Ali",
			"Woody Harrelson",
			"Vince Vaughn",
		],
		creators: ["Issa L\u00f3pez", "Nic Pizzolatto", "Cary Joji Fukunaga", "John Crowley", "Justin Lin"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Passenger",
			"Anonymous Content",
			"Lee Caplin / Picture Entertainment",
			"Neon Black",
			"Parliament of Owls",
			"HBO",
			"Peligrosa",
			"PASTEL",
		],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Persona",
		description:
			"After being diagnosed with Alzheimer's, a retired judicial officer decides to commit a murder that he had been planning for years.",
		release_date: "2018-03-17",
		imdb_id: "tt7920978",
		imdb_rating: "8.137",
		vote_count: "146",
		popularity: "37.808",
		youtube_trailer_key: "bm1QlbYbhzM",
		rated: "TV-MA",
		runtime: 67,
		year_started: 2018,
		genres: ["Crime", "Drama", "Mystery", "Suspense", "Thriller", "Mini-Series"],
		stars: [
			"Haluk Bilginer",
			"Erdal \u00d6zya\u011fc\u0131lar",
			"\u015eebnem Bozoklu",
			"\u0130lker Aksum",
			"Recep Usta",
			"Cansu Dere",
			"Metin Akd\u00fclger",
			"Necip Memili",
			"\u0130brahim Selim",
			"F\u0131rat Topkorur",
		],
		creators: ["Hakan G\u00fcnday"],
		countries: ["TR", "Tr"],
		language: ["tr", "en"],
		production_companies: ["Ay Yap\u0131m"],
		networks: ["puhutv", "GA\u0130N", "Gain", "GAIN"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Cowboy Bebop",
		description:
			'In 2071, roughly fifty years after an accident with a hyperspace gateway made the Earth almost uninhabitable, humanity has colonized most of the rocky planets and moons of the Solar System. Amid a rising crime rate, the Inter Solar System Police (ISSP) set up a legalized contract system, in which registered bounty hunters, also referred to as "Cowboys", chase criminals and bring them in alive in return for a reward.',
		release_date: "1998-04-03",
		imdb_id: "tt0213338",
		imdb_rating: "8.536",
		vote_count: "1513",
		popularity: "434.294",
		youtube_trailer_key: "OhNwckCLzis",
		rated: "TV-14",
		runtime: 25,
		year_started: 1998,
		genres: [
			"Animation",
			"Action",
			"Adventure",
			"Fantasy",
			"Sci-Fi",
			"Western",
			"Anime",
			"Comedy",
			"Drama",
			"Crime",
			"Sci-Fi",
		],
		stars: [
			"Koichi Yamadera",
			"Unsho Ishizuka",
			"Megumi Hayashibara",
			"Aoi Tada",
			"Norio Wakamoto",
			"Gara Takashima",
			"K\u00f4ichi Yamadera",
			"Unsh\u00f4 Ishizuka",
			"Kouichi Yamadera",
			"Steve Blum",
			"Wendee Lee",
			"Beau Billingslea",
		],
		creators: [
			"Shinichiro Watanabe",
			"Hajime Yatate",
			"Shinichir\u00f4 Watanabe",
			"Yoshiyuki Takei",
			"Ikur\u00f4 Sat\u00f4",
		],
		countries: ["JP", "Jp"],
		language: ["ja", "en", "Japanese, English"],
		production_companies: ["SUNRISE", "Bandai Visual", "Sound Box"],
		networks: ["TV Tokyo", "WOWOW Prime", "WOWOW"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Fargo",
		description:
			"A close-knit anthology series dealing with stories involving malice, violence and murder based in and around Minnesota.",
		release_date: "2014-04-15",
		imdb_id: "tt2802850",
		imdb_rating: "8.295",
		vote_count: "2474",
		popularity: "693.943",
		youtube_trailer_key: "setgvHG3w48",
		rated: "TV-MA",
		runtime: 53,
		year_started: 2014,
		genres: ["Crime", "Drama", "Thriller", "Comedy"],
		stars: [
			"Juno Temple",
			"Jennifer Jason Leigh",
			"David Rysdahl",
			"Joe Keery",
			"Lamorne Morris",
			"Richa Shukla Moorjani",
			"Sam Spruell",
			"Sienna King",
			"Dave Foley",
			"Jon Hamm",
			"Chris Rock",
			"Jessie Buckley",
		],
		creators: ["Noah Hawley", "Michael Uppendahl", "Keith Gordon", "Randall Einhorn"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"26 Keys Productions",
			"The Littlefield Company",
			"Mike Zoss Productions",
			"MGM Television",
			"FX Productions",
			"Littlefield Company",
		],
		networks: ["FX", "FX (US)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Nathan for You",
		description:
			'Self-proclaimed business expert, writer, director and comedian Nathan Fielder helps real small businesses turn a profit with marketing tactics that no ordinary consultant would dare to attempt. From driving foot traffic to an off-the-strip souvenir shop by using Hollywood flair and a Johnny Depp impersonator, to creating a rebate that can only be redeemed by climbing a mountain, to founding a coffee shop called "Dumb Starbucks,\u201d Nathan has always gone to the limit to make his ideas come to life. With his unorthodox approach to problem solving, Nathan\u2019s genuine efforts to do good often draw the real people he encounters into an experience far beyond what they signed up for.',
		release_date: "2013-02-28",
		imdb_id: "tt2297757",
		imdb_rating: "8.134",
		vote_count: "202",
		popularity: "86.243",
		youtube_trailer_key: "Sx8cRWbGlNo",
		rated: "TV-14",
		runtime: 21,
		year_started: 2013,
		genres: ["Comedy", "Documentary", "Reality-TV", "Reality"],
		stars: [
			"Nathan Fielder",
			"Anthony Filosa",
			"William Heath",
			"Anthony Napoli",
			"Cornelius Ladd",
			"Billy Smalling",
			"Marcos Mateo Ochoa",
			"Brian S. Wolfe",
			"Jason Stone",
			"Corey Calderwood",
			"Jennifer Anderton",
			"James Bailey",
		],
		creators: ["Nathan Fielder", "Michael Koman", "Jason Woliner"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["WDM", "Abso Lutely Productions", "Blow Out", "Blow Out Productions"],
		networks: ["Comedy Central", "Comedy Central (US)"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "As If",
		description:
			"Y\u0131lmaz and \u0130lkkan are two friends who are constantly fighting each other. Their biggest feature is always being able to do things that will turn their ordinary lives upside down. They magnify small events incredibly and give you a nervous breakdown. They are the embodiment of the misfortunes, strange events and despair we experience every day.",
		release_date: "2020-12-31",
		imdb_id: "tt13675832",
		imdb_rating: "8.3",
		vote_count: "196",
		popularity: "1.4",
		youtube_trailer_key: "TGcxboQ3kY4",
		rated: "30min                          ",
		runtime: 40,
		year_started: 2020,
		genres: ["Comedy"],
		stars: [
			"Feyyaz Yi\u011fit",
			"K\u0131van\u00e7 K\u0131l\u0131n\u00e7",
			"Ahmet K\u00fcr\u015fat \u00d6\u00e7alan",
			"Feyyaz Yigit",
			"Ahmet Kursat Ocalan",
			"Kivan\u00e7 Kilin\u00e7",
		],
		creators: null,
		countries: ["Tr"],
		language: ["tr", "en"],
		production_companies: null,
		networks: ["Exxen", "EXXEN"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Apocalypse: La 2\u00e8me guerre mondiale",
		description:
			"A six-part French documentary about the Second World War composed exclusively of actual footage of the war as filmed by war correspondents, soldiers, resistance fighters and private citizens. The series is shown in color, with the black and white footage being fully colorized, save for some original color footage. The only exception to the treatment are most Holocaust scenes, which are presented in the original black and white.",
		release_date: "2009-09-08",
		imdb_id: "tt1508238",
		imdb_rating: "8.3",
		vote_count: "59",
		popularity: "10.301",
		youtube_trailer_key: "TDoce5gefak",
		rated: "TV-PG",
		runtime: 50,
		year_started: 2009,
		genres: ["War", "Documentary", "History"],
		stars: [
			"Mathieu Kassovitz",
			"Dwight D. Eisenhower",
			"Adolf Hitler",
			"Franklin D. Roosevelt",
			"Charles de Gaulle",
			"Heinrich Himmler",
			"Erwin Rommel",
			"Joseph Stalin",
			"Hermann G\u00f6ring",
			"Winston Churchill",
			"Benito Mussolini",
			"Martin Sheen",
		],
		creators: ["Isabelle Clarke", "Daniel Costelle", "Jean-Louis Guillaud", "Henry de Turenne"],
		countries: ["FR", "Fr"],
		language: ["fr", "en", "French"],
		production_companies: [
			"CC&C \u2013 Clarke Costelle et Cie",
			"\u00c9tablissement de Communication et de Production Audiovisuelle de la D\u00e9fense (ECPAD)",
			"NHK",
			"France 2",
			"National Geographic",
		],
		networks: ["France 2"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Taskmaster",
		description:
			"Greg Davies is the Taskmaster, and with the help of his ever-loyal assistant Alex Horne, they will set out to test the wiles, wit, wisdom and skills of five hyper-competitive comedians. Who will be crowned the Taskmaster champion in this brand new game show?",
		release_date: "2015-07-28",
		imdb_id: "tt4934214",
		imdb_rating: "8.4",
		vote_count: "120",
		popularity: "112.236",
		youtube_trailer_key: "hiutY6RDZHg",
		rated: "TV-14",
		runtime: 45,
		year_started: 2015,
		genres: ["Comedy", "Game-show", "Game Show"],
		stars: [
			"Greg Davies",
			"Alex Horne",
			"Joanne McNally",
			"John Robins",
			"Nick Mohammed",
			"Sophie Willan",
			"Steve Pemberton",
			"Asim Chaudhry",
			"Russell Howard",
			"Alice Levine",
			"Liza Tarbuck",
			"Tim Vine",
		],
		creators: ["Alex Horne", "Andy Devonshire", "Peter Orton"],
		countries: ["UK"],
		language: ["en", "sv", "English"],
		production_companies: ["Avalon Television", "Avalon"],
		networks: ["Channel 4", "Dave", "YouTube"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "When They See Us",
		description:
			"Five teens from Harlem become trapped in a nightmare when they're falsely accused of a brutal attack in Central Park.",
		release_date: "2019-05-31",
		imdb_id: "tt7137906",
		imdb_rating: "8.2",
		vote_count: "757",
		popularity: "115.425",
		youtube_trailer_key: "YyoSErErnCE",
		rated: "TV-MA",
		runtime: 75,
		year_started: 2019,
		genres: ["Drama", "Crime", "History", "Mini-Series", "Biography", "Thriller"],
		stars: [
			"Jharrel Jerome",
			"Ethan Herisse",
			"Marquis Rodriguez",
			"Asante Blackk",
			"Caleel Harris",
			"Marsha Stephanie Blake",
			"Michael Kenneth Williams",
			"John Leguizamo",
			"Aunjanue Ellis-Taylor",
			"Niecy Nash-Betts",
			"Niecy Nash",
			"Aunjanue Ellis",
		],
		creators: ["Ava DuVernay"],
		countries: ["USA"],
		language: ["en"],
		production_companies: [
			"Participant",
			"Harpo Films",
			"Tribeca Productions",
			"Forward Movement",
			"ARRAY Filmworks",
			"Participant Media",
		],
		networks: ["Netflix"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Last Week Tonight with John Oliver",
		description: "A half-hour satirical look at the week in news, politics and current events.",
		release_date: "2014-04-27",
		imdb_id: "tt3530232",
		imdb_rating: "7.877",
		vote_count: "640",
		popularity: "619.147",
		youtube_trailer_key: "s3gUpyEI_rQ",
		rated: "TV-MA",
		runtime: 30,
		year_started: 2014,
		genres: ["Talk Show", "Comedy", "News", "Talk-show", "History", "Talk-Show"],
		stars: [
			"John Oliver",
			"David Kaye",
			"Ryan Barger",
			"Noel MacNeal",
			"Alberto Bonilla",
			"Paul McGinnis",
			"Thomas Kopache",
			"James Wojtal",
			"Frances Mitchell",
			"Kyle Ploof",
			"Rachel Dratch",
			"Nick Offerman",
		],
		creators: ["John Oliver", "Joe Perota", "Christopher Werner", "Paul Pennolino"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: [
			"Sixteen String Jack Productions",
			"Avalon Television",
			"Partially Important Productions",
		],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Africa",
		description:
			"Africa, the world's wildest continent. David Attenborough takes us on an awe-inspiring journey through one of the most diverse places in the world. We visit deserts, savannas, and jungles and meet up with some of Africa's amazing wildlife.",
		release_date: "2013-01-02",
		imdb_id: "tt2571774",
		imdb_rating: "8.3",
		vote_count: "81",
		popularity: "13.074",
		youtube_trailer_key: "5YcDDXUhOgU",
		rated: "TV-Y",
		runtime: 50,
		year_started: 2013,
		genres: ["Documentary"],
		stars: [
			"David Attenborough",
			"Simon Blakeney",
			"James Aldred",
			"Katrina Bartlam",
			"Tim Berrow",
			"Andres Bifani",
			"Paul Brehem",
			"Kate Broome",
			"Kahindi Changawa",
			"Martyn Colbeck",
			"Mark Deeble",
			"Stephanie Dolrenry",
		],
		creators: ["David Attenborough", "Katrina Bartlam", "Ben Aviss", "Nick Easton"],
		countries: ["UK"],
		language: ["en", "English"],
		production_companies: ["WVG Medien GmbH", "BBC"],
		networks: ["BBC One"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Friends",
		description:
			"Six young people from New York City, on their own and struggling to survive in the real world, find the companionship, comfort and support they get from each other to be the perfect antidote to the pressures of life.",
		release_date: "1994-09-22",
		imdb_id: "tt0108778",
		imdb_rating: "8.44",
		vote_count: "7753",
		popularity: "799.997",
		youtube_trailer_key: "IEEbUzffzrk",
		rated: "TV-14",
		runtime: 22,
		year_started: 1994,
		genres: ["Comedy", "Drama", "Romance"],
		stars: [
			"Jennifer Aniston",
			"Courteney Cox",
			"Lisa Kudrow",
			"Matt LeBlanc",
			"Matthew Perry",
			"David Schwimmer",
			"James Michael Tyler",
			"Elliott Gould",
			"Christina Pickles",
			"Maggie Wheeler",
			"Paul Rudd",
			"Jane Sibbett",
		],
		creators: ["Marta Kauffman", "David Crane", "Gary Halvorson", "Kevin Bright", "Michael Lembeck"],
		countries: ["USA"],
		language: ["en", "English, Dutch, Italian, French"],
		production_companies: ["Warner Bros. Television", "Bright/Kauffman/Crane Productions"],
		networks: ["NBC"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Succession",
		description:
			"Follow the lives of the Roy family as they contemplate their future once their aging father begins to step back from the media and entertainment conglomerate they control.",
		release_date: "2018-06-03",
		imdb_id: "tt7660850",
		imdb_rating: "8.259",
		vote_count: "1032",
		popularity: "204.24",
		youtube_trailer_key: "OzYxJV_rmE8",
		rated: "TV-MA",
		runtime: 60,
		year_started: 2018,
		genres: ["Drama", "Comedy"],
		stars: [
			"Jeremy Strong",
			"Kieran Culkin",
			"Sarah Snook",
			"Brian Cox",
			"Matthew Macfadyen",
			"Alan Ruck",
			"J. Smith-Cameron",
			"Nicholas Braun",
			"Dagmara Domi\u0144czyk",
			"Peter Friedman",
			"Hiam Abbass",
			"Natalie Gold",
		],
		creators: ["Jesse Armstrong", "Mark Mylod", "Adam Arkin", "Adam McKay"],
		countries: ["USA"],
		language: ["en", "N/A"],
		production_companies: ["Gary Sanchez Productions", "Hyperobject Industries", "Project Zeus", "HBO"],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "TVF Pitchers",
		description:
			"A story of trials and tribulations of four young entrepreneurs who quit their day jobs in order to pursue their start up venture.",
		release_date: "2015-06-03",
		imdb_id: "tt4742876",
		imdb_rating: "7.5",
		vote_count: "51",
		popularity: "46.297",
		youtube_trailer_key: "XCT337KXfEc",
		rated: "TV-MA",
		runtime: 40,
		year_started: 2015,
		genres: ["Comedy", "Drama"],
		stars: [
			"Jitendra Kumar",
			"Abhay Mahajan",
			"Naveen Kasturia",
			"Arunabh Kumar",
			"Arnav Bhasin",
			"Gopal Dutt",
			"Maanvi Gagroo",
			"Pranav Bhasin",
			"Biswapati Sarkar",
			"Rajesh Sharma",
			"Suneel Sinha",
			"Akanksha Thakur",
		],
		creators: ["Arunabh Kumar", "Amit Golani"],
		countries: ["IN", "In", "USA"],
		language: ["hi", "en", "Hindi, English"],
		production_companies: ["The Viral Fever Media Labs"],
		networks: ["TVFPlay ", "TVFPlay", "YouTube"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "It's Always Sunny in Philadelphia",
		description:
			"Four egocentric friends run a neighborhood Irish pub in Philadelphia and try to find their way through the adult world of work and relationships. Unfortunately, their warped views and precarious judgments often lead them to trouble, creating a myriad of uncomfortable situations that usually only get worse before they get better.",
		release_date: "2005-08-04",
		imdb_id: "tt0472954",
		imdb_rating: "8.308",
		vote_count: "1013",
		popularity: "1052.88",
		youtube_trailer_key: "blLAdGYPhiQ",
		rated: "TV-MA",
		runtime: 22,
		year_started: 2005,
		genres: ["Comedy", "Drama"],
		stars: [
			"Charlie Day",
			"Glenn Howerton",
			"Rob McElhenney",
			"Kaitlin Olson",
			"Danny DeVito",
			"Mary Elizabeth Ellis",
			"David Hornsby",
			"Artemis Pebdani",
			"Lynne Marie Stewart",
			"Sandy Martin",
			"Lance Barber",
			"Jimmi Simpson",
		],
		creators: ["Rob McElhenney", "Matt Shakman", "Fred Savage", "Daniel Attias"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["3 Arts Entertainment", "Bluebush Productions", "FX Productions", "RCG Productions"],
		networks: ["FX", "FXX"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "X-Men '97",
		description:
			"The X-Men, a band of mutants who use their uncanny gifts to protect a world that hates and fears them, are challenged like never before, forced to face a dangerous and unexpected new future.",
		release_date: "2024-03-20",
		imdb_id: "tt16026746",
		imdb_rating: "8.825",
		vote_count: "300",
		popularity: "638.368",
		youtube_trailer_key: "mp1Pax-QHlA",
		rated: "TV-14",
		runtime: 42,
		year_started: 2024,
		genres: ["Animation", "Action", "Adventure", "Fantasy", "Sci-Fi"],
		stars: [
			"Ray Chase",
			"Jennifer Hale",
			"Alison Sealy-Smith",
			"Cal Dodd",
			"JP Karliak",
			"Lenore Zann",
			"George Buza",
			"A.J. LoCascio",
			"Holly Chou",
			"Isaac Robinson-Smith",
			"Cathal J. Dodd",
		],
		creators: null,
		countries: ["USA"],
		language: ["en"],
		production_companies: ["Marvel Studios", "Marvel Animation"],
		networks: ["Disney+"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "The West Wing",
		description:
			"The West Wing provides a glimpse into presidential politics in the nation's capital as it tells the stories of the members of a fictional presidential administration. These interesting characters have humor and dedication that touches the heart while the politics that they discuss touch on everyday life.",
		release_date: "1999-09-22",
		imdb_id: "tt0200276",
		imdb_rating: "8.263",
		vote_count: "446",
		popularity: "1120.6",
		youtube_trailer_key: "r60Nw2fWgvw",
		rated: "TV-14",
		runtime: 45,
		year_started: 1999,
		genres: ["Drama"],
		stars: [
			"Martin Sheen",
			"Allison Janney",
			"Richard Schiff",
			"John Spencer",
			"Bradley Whitford",
			"Dul\u00e9 Hill",
			"Joshua Malina",
			"Janel Moloney",
			"Alan Alda",
			"Jimmy Smits",
			"Stockard Channing",
			"Rob Lowe",
		],
		creators: ["Aaron Sorkin", "Christopher Misiano", "Alex Graves", "Thomas Schlamme"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["John Wells Productions", "Warner Bros. Television"],
		networks: ["NBC"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Monty Python's Flying Circus",
		description:
			"A British sketch comedy series with the shows being composed of surreality, risqu\u00e9 or innuendo-laden humour, sight gags and observational sketches without punchlines.",
		release_date: "1969-10-05",
		imdb_id: "tt0063929",
		imdb_rating: "8.24",
		vote_count: "584",
		popularity: "263.628",
		youtube_trailer_key: "YULeGnKPdbM",
		rated: "TV-14",
		runtime: 30,
		year_started: 1969,
		genres: ["Comedy"],
		stars: [
			"Graham Chapman",
			"Michael Palin",
			"Terry Jones",
			"Eric Idle",
			"Terry Gilliam",
			"John Cleese",
			"Connie Booth",
			"Ian Davidson",
			"Carol Cleveland",
			"John Hughman",
			"The Fred Tomlinson Singers",
			"Bob Raymond",
		],
		creators: ["Ian MacNaughton", "John Howard Davies"],
		countries: ["UK"],
		language: ["en", "English, Arabic, French, German, Italian, Mandarin, Spanish"],
		production_companies: ["BBC"],
		networks: ["BBC One", "BBC Two", "PBS", "ARD"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Curb Your Enthusiasm",
		description:
			"The off-kilter, unscripted comic vision of Larry David, who plays himself in a parallel universe in which he can't seem to do anything right, and, by his standards, neither can anyone else.",
		release_date: "2000-10-15",
		imdb_id: "tt0264235",
		imdb_rating: "8.023",
		vote_count: "696",
		popularity: "1072.61",
		youtube_trailer_key: "4AR9Dqi3CVc",
		rated: "TV-MA",
		runtime: 42,
		year_started: 2000,
		genres: ["Comedy", "Drama"],
		stars: [
			"Larry David",
			"Jeff Garlin",
			"Susie Essman",
			"Cheryl Hines",
			"J.B. Smoove",
			"Richard Lewis",
			"Bob Einstein",
			"Ted Danson",
			"Ashly Holloway",
			"Shelley Berman",
			"Antoinette Spolar",
			"Vivica A. Fox",
		],
		creators: ["Larry David", "Robert B. Weide", "Larry Charles", "Bryan Gordon"],
		countries: ["USA"],
		language: ["en", "English"],
		production_companies: ["HBO"],
		networks: ["HBO"],
		status: "OK",
		status_message: "Query was successful",
	},
	{
		title: "Das Boot",
		description:
			"In the Autumn of 1941, a young war correspondent is assigned to accompany German submarine U-96 on a patrol through the Atlantic.",
		release_date: "1985-02-24",
		imdb_id: "tt0081834",
		imdb_rating: "8.2",
		vote_count: "151",
		popularity: "9.702",
		youtube_trailer_key: "7pzKyeIex2Y&t=8s",
		rated: "TV-MA     ",
		runtime: 51,
		year_started: 1985,
		genres: ["Drama", "War", "Thriller"],
		stars: [
			"J\u00fcrgen Prochnow",
			"Hubertus Bengsch",
			"Klaus Wennemann",
			"Herbert Gr\u00f6nemeyer",
			"Martin Semmelrogge",
			"Uwe Ochsenknecht",
			"Erwin Leder",
			"Jan Fedder",
			"Claude-Oliver Rudolph",
			"Ralf Richter",
			"G\u00fcnter Lamprecht",
			"Otto Sander",
		],
		creators: ["Wolfgang Petersen", "G\u00fcnter Rohrbach"],
		countries: ["DE", "De"],
		language: ["de", "German"],
		production_companies: ["Bavaria Film", "S\u00fcdwestdeutscher Rundfunk", "Westdeutscher Rundfunk"],
		networks: ["ARD", "Das Erste"],
		status: "OK",
		status_message: "Query was successful",
	},
];

const getTvImageUrl = (id) => {
	return `/data/tvShowPosters/${id}.jpg`;
};

function filterTopTVShows(tvs) {
	return tvs.map((element) => {
		const actors = element.stars ? element.stars.slice(0, 3) : [];
		return {
			id: element.imdb_id,
			metaScore: element.metacritic?.metascore?.score || "N/A",
			rating: `${parseFloat(element.imdb_rating).toFixed(1)}` || "N/A",
			title: element.title || "N/A",
			description: element.description || "No description available",
			img: getTvImageUrl(element.imdb_id),
			releaseYear: element.year_started || element.year || "N/A",
			actors: actors,
			genres: element.genres.map((genre) => genre) || [],
			trailer: "https://www.youtube.com/watch?v=" + element.youtube_trailer_key,
		};
	});
}

export default filterTopTVShows(topRatedTvShows);
